// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.address-modal-overlay {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(36, 41, 57, 0.18);
  z-index: 2000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  box-sizing: border-box;
  padding-top: max(12px, env(safe-area-inset-top, 0px));
}

.address-modal-sheet {
  width: 100%;
  max-width: 420px;
  max-height: calc(100vh - 12px);
  max-height: calc(100dvh - max(12px, env(safe-area-inset-top, 0px)));
  min-width: 210px;
  background: #fff;
  border-top-left-radius: 22px;
  border-top-right-radius: 22px;
  padding: 22px 18px calc(12px + env(safe-area-inset-bottom, 0px));
  box-shadow: 0 -2px 24px rgba(36, 41, 57, 0.11);
  animation: modalUp 0.28s cubic-bezier(0.32, 1.4, 0.41, 0.9);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.address-modal-title {
  font-size: 1.11rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: #232137;
  text-align: center;
  flex: 0 0 auto;
}

.address-modal-list {
  margin: 0 0 16px 0;
  padding: 0;
  list-style: none;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.address-modal-list li {
  padding: 10px 7px;
  margin-bottom: 3px;
  border-radius: 10px;
  font-size: 1.02rem;
  color: #232137;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  transition: background 0.14s;
  overflow-wrap: anywhere;
}

.address-modal-list li.active {
  background: #f7e5eb;
  color: #e72f44;
  font-weight: 700;
}

.address-modal-list li:active {
  background: #eee3e8;
}

.address-check {
  margin-left: 8px;
  color: #e72f44;
  font-size: 1.1em;
  flex: 0 0 auto;
}

.address-modal-close {
  display: block;
  width: 100%;
  background: #232137;
  color: #fff;
  font-size: 1.01rem;
  font-weight: 600;
  border: none;
  border-radius: 17px;
  padding: 12px 0 8px 0;
  margin: 4px 0 0 0;
  cursor: pointer;
  min-height: 44px;
  flex: 0 0 auto;
}

.header-bell {
  width: 38px;
  height: 38px;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 4px 16px 0 rgba(36, 41, 57, 0.07);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  margin-left: 10px;
  flex: 0 0 auto;
  position: relative;
}

.header-bell-badge {
  position: absolute;
  top: -6px;
  right: -8px;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: #e72f44;
  color: #fff;
  font-size: 11px;
  line-height: 20px;
  font-weight: 700;
  text-align: center;
  box-shadow: 0 8px 16px rgba(231, 47, 68, 0.28);
}

.header-bell:active {
  transform: translateY(1px);
}

.header-load-error {
  margin: 0 12px 12px;
  padding: 12px 16px;
  border-radius: 12px;
  background: #fff0f2;
  color: #9d1930;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.header-load-error button {
  border: 0;
  border-radius: 8px;
  padding: 8px 12px;
  background: #e72f44;
  color: #fff;
  font: inherit;
  cursor: pointer;
}

/* mobile-friendly */
@media (max-width: 430px) {
  .header-bell {
    width: 44px;
    height: 44px;
    border-radius: 14px;
    margin-left: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/block/MenuHeader/menuHeader.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,kCAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,sBAAA;EACA,qDAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,mEAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;EACA,gEAAA;EACA,8CAAA;EACA,2DAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,4BAAA;EACA,iCAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,4BAAA;EACA,uBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AACA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,+CAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAEF;;AACA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8CAAA;AAEF;;AACA;EACE,0BAAA;AAEF;;AACA;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAEF;;AACA;EACE,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;AAEF;;AACA,oBAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;IACA,mBAAA;IACA,gBAAA;EAEF;AACF","sourcesContent":[".address-modal-overlay {\n  position: fixed;\n  left: 0;\r\n  right: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  background: rgba(36, 41, 57, 0.18);\r\n  z-index: 2000;\r\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  box-sizing: border-box;\n  padding-top: max(12px, env(safe-area-inset-top, 0px));\n}\n\n.address-modal-sheet {\n  width: 100%;\n  max-width: 420px;\n  max-height: calc(100vh - 12px);\n  max-height: calc(100dvh - max(12px, env(safe-area-inset-top, 0px)));\n  min-width: 210px;\n  background: #fff;\n  border-top-left-radius: 22px;\n  border-top-right-radius: 22px;\n  padding: 22px 18px calc(12px + env(safe-area-inset-bottom, 0px));\n  box-shadow: 0 -2px 24px rgba(36, 41, 57, 0.11);\n  animation: modalUp .28s cubic-bezier(.32, 1.4, .41, .9);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\r\n.address-modal-title {\n  font-size: 1.11rem;\n  font-weight: 700;\n  margin-bottom: 12px;\n  color: #232137;\n  text-align: center;\n  flex: 0 0 auto;\n}\n\r\n.address-modal-list {\n  margin: 0 0 16px 0;\n  padding: 0;\n  list-style: none;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n\r\n.address-modal-list li {\r\n  padding: 10px 7px;\r\n  margin-bottom: 3px;\r\n  border-radius: 10px;\r\n  font-size: 1.02rem;\r\n  color: #232137;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  transition: background 0.14s;\n  overflow-wrap: anywhere;\n}\n\r\n.address-modal-list li.active {\r\n  background: #f7e5eb;\r\n  color: #e72f44;\r\n  font-weight: 700;\r\n}\r\n\r\n.address-modal-list li:active {\r\n  background: #eee3e8;\r\n}\r\n\r\n.address-check {\n  margin-left: 8px;\n  color: #e72f44;\n  font-size: 1.1em;\n  flex: 0 0 auto;\n}\n\r\n.address-modal-close {\r\n  display: block;\r\n  width: 100%;\r\n  background: #232137;\r\n  color: #fff;\r\n  font-size: 1.01rem;\r\n  font-weight: 600;\r\n  border: none;\r\n  border-radius: 17px;\r\n  padding: 12px 0 8px 0;\r\n  margin: 4px 0 0 0;\n  cursor: pointer;\n  min-height: 44px;\n  flex: 0 0 auto;\n}\n.header-bell {\n  width: 38px;\n  height: 38px;\n  border-radius: 14px;\r\n  background: #fff;\r\n  box-shadow: 0 4px 16px 0 rgba(36, 41, 57, 0.07);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\n  text-decoration: none;\n  margin-left: 10px;\n  flex: 0 0 auto;\n  position: relative;\n}\n\n.header-bell-badge {\n  position: absolute;\n  top: -6px;\n  right: -8px;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: #e72f44;\n  color: #fff;\n  font-size: 11px;\n  line-height: 20px;\n  font-weight: 700;\n  text-align: center;\n  box-shadow: 0 8px 16px rgba(231, 47, 68, 0.28);\n}\n\n.header-bell:active {\n  transform: translateY(1px);\n}\n\n.header-load-error {\n  margin: 0 12px 12px;\n  padding: 12px 16px;\n  border-radius: 12px;\n  background: #fff0f2;\n  color: #9d1930;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.header-load-error button {\n  border: 0;\n  border-radius: 8px;\n  padding: 8px 12px;\n  background: #e72f44;\n  color: #fff;\n  font: inherit;\n  cursor: pointer;\n}\n\r\n/* mobile-friendly */\r\n@media (max-width: 430px) {\n  .header-bell {\n    width: 44px;\n    height: 44px;\n    border-radius: 14px;\n    margin-left: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
